import loadable from "utils/loadable";

export const HalamanRegister = loadable(() => import("./index"));
export const SignUpCard = loadable(() => import("./SignUpCard"));
